module.exports = __webpack_public_path__ + "static/media/logo.7632aca2.png";